module.exports = __webpack_public_path__ + "static/cartepostale-DEI-ecole-1200-63e72fb1b9fb0101d5ee90dcaec8ff5a.png";